<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Создать компанию</strong>
                </CCardHeader>
                <CCardBody>
                    <CForm>
                        <CInput v-model="form.title" label="Название" :horizontal="true" />
                        <CInput v-model="form.legal_entity" label="Юр. лицо" :horizontal="true" />
                        <CInput v-model="form.inn" label="ИНН" :horizontal="true" />
                        <CSelect
                            :value.sync="form.program_type"
                            :horizontal="true"
                            :options="programOptions"
                            label="Тип программы"
                        />
                        <CSelect
                            :value.sync="form.tariff_preset"
                            :horizontal="true"
                            :options="tariffOptions"
                            label="Тариф"
                        />
                        <CInput
                            v-if="form.tariff_preset === 'custom'"
                            v-model.number="form.tariff_amount"
                            type="number"
                            label="Кастомная сумма, ₽"
                            :horizontal="true"
                        />
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton color="primary" :disabled="saving" @click="save">Создать</CButton>
                    <CButton color="secondary" class="ml-2" @click="$router.push('/business-companies')">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';

    export default {
        name: 'BusinessCompanyCreate',
        data() {
            return {
                saving: false,
                form: {
                    title: '',
                    legal_entity: '',
                    inn: '',
                    program_type: 'prepaid',
                    tariff_preset: '20000',
                    tariff_amount: 20000
                },
                programOptions: [
                    { value: 'prepaid', label: 'Предоплата' },
                    { value: 'installment', label: 'Рассрочка' }
                ],
                tariffOptions: [
                    { value: '20000', label: '20 000 ₽' },
                    { value: '50000', label: '50 000 ₽' },
                    { value: '100000', label: '100 000 ₽' },
                    { value: 'custom', label: 'Кастомная сумма' }
                ]
            };
        },
        methods: {
            async save() {
                if (!this.form.title) {
                    this.$root.$emit('showError', 'Укажите название компании.');
                    return;
                }
                this.saving = true;
                try {
                    const { data } = await Vue.axios.post('/companies', this.form);
                    this.$router.push(`/business-companies/${data.id}`);
                } catch (err) {
                    this.$root.$emit('showError', err.response?.data?.error || 'Не удалось создать компанию.');
                } finally {
                    this.saving = false;
                }
            }
        }
    };
</script>
